module.exports = __webpack_public_path__ + "img/cdbg02.6ebda1e9.png";